import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";
import { LoggerFactory } from "../../../utilities/logger";
import { BrowserKinds, BrowserUtility } from "../../../utilities";

export class LayerImageSource extends AbstractSource {
  constructor(getToken: () => string, public formatId: number, public key: string) {
    super(getToken);
  }

  protected getSource(): string {
    const shouldResizeImage = (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer);
    const url = "/api/format/" + this.formatId + "/layer/" + this.key + "?token=" + this.token + "&shouldResizeImage=" + shouldResizeImage;
    LayerImageSource._logger.debug("source: " + url);
    return url;
  }

  public clone(): IContentSource {
    return new LayerImageSource(
      this._getToken,
      this.formatId,
      this.key
    );
  }

  private static readonly _logger = LoggerFactory.getLogger();
}
